import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import { ChangedFieldsCell as GenericChangedFieldsCell } from '@/modules/common/components/changed-fields';

import { TimeOffChangedField } from '../../../types/time-off-changes';
import { createTimeOffChangedFieldsStrategy } from './time-off-changed-fields.strategy';

interface ChangedFieldsCellProps {
  changedFields: TimeOffChangedField[];
}

/**
 * Time-off-type-specific "Changed Fields" cell. Thin wrapper that feeds the
 * time-off field list and strategy into the shared generic cell.
 */
export const ChangedFieldsCell = ({ changedFields }: ChangedFieldsCellProps) => {
  // Subscribe to i18n so the memoized strategy rebuilds on language change.
  const { i18n } = useTranslation('authenticated.settings');
  const strategy = useMemo(() => createTimeOffChangedFieldsStrategy(), [i18n.language]);

  return <GenericChangedFieldsCell fields={changedFields} strategy={strategy} />;
};
